import _ from "underscore";
import i18n from '../../i18n.js';

export const AgentStatus = {
  IDLE: {
    id: "IDLE",
    text: i18n.t('agents.statuses.idle'),
    color: "#888"
  },
  STARTING: {
    id: "STARTING",
    text: i18n.t('agents.statuses.starting'),
    color: "#ff8800"
  },
  RUNNING: {
    id: "RUNNING",
    text: i18n.t('agents.statuses.running'),
    color: "#007e33"
  },
  ERROR: {
    id: "ERROR",
    text: i18n.t('agents.statuses.error'),
    color: "#cc0000"
  },
  STOPPING: {
    id: "STOPPING",
    text: i18n.t('agents.statuses.stopping'),
    color: "#ff8800"
  },
  STOPPED: {
    id: "STOPPED",
    text: i18n.t('agents.statuses.stopped'),
    color: "#ff8800"
  }
};

export const agentStatusDataSourceConfig = {
  store: {
    type: "array",
    data: _.values(AgentStatus),
    key: "id"
  },
  map: rec => _.extend({ value: rec.id }, rec)
}

export const formatAgentStatusText = key =>
  key in AgentStatus ? AgentStatus[key].text : key;

export const formatAgentStatusColor = key =>
  key in AgentStatus ? AgentStatus[key].color : "unset";
